export { default as homeInit } from "./init-home";
export { default as heroOut } from "./hero-out";
export { default as heroIn } from "./hero-in";
export { default as projChange } from "./proj-in-out";
export { default as projIn } from "./proj-in";
export { default as projOut } from "./proj-out";
export { default as projLeave } from "./to-proj-leave";
export { default as studyEnter } from "./to-proj-enter";
export { default as contact } from "./contact";
export { default as studyLeave } from "./study-leave";
export { default as nxtInOut } from "./next-project-in-out";
export { default as fromSudyLeave } from "./from-study-leave";
export { default as aboutEnter } from "./about-enter";
export { default as aboutLeave } from "./about-leave";
